/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.2 routes of ALoop::Application.
 * @version 0273ef4aa55bdb69ef4277bc300924dff163ea118198441619074a5775f71c7f
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /admin/announcements/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnnouncementPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcement_file_presigned_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnnouncementFilePresignedUrlsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcement_file_presigned_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnnouncementsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bi_tool(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBiToolPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bi_tool"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessEntitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entities/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessEntityPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entities"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entity_info_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessEntityInfoApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entity_info_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entity_info_applications/:business_entity_info_application_id/draft(.:format)
 * @param {any} businessEntityInfoApplicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessEntityInfoApplicationDraftPath = /*#__PURE__*/ __jsr.r({"business_entity_info_application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entity_info_applications"],[2,[7,"/"],[2,[3,"business_entity_info_application_id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entity_info_applications/:business_entity_info_application_id/examination_result(.:format)
 * @param {any} businessEntityInfoApplicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessEntityInfoApplicationExaminationResultPath = /*#__PURE__*/ __jsr.r({"business_entity_info_application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entity_info_applications"],[2,[7,"/"],[2,[3,"business_entity_info_application_id"],[2,[7,"/"],[2,[6,"examination_result"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entity_info_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessEntityInfoApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entity_info_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/draft_first_business_entity_info_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDraftFirstBusinessEntityInfoApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"draft_first_business_entity_info_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/draft_first_business_entity_info_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDraftFirstBusinessEntityInfoApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"draft_first_business_entity_info_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_setting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventSettingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/posts/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPostPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/post_comments/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPostCommentPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"post_comments"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/post_comment_replies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPostCommentRepliesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"post_comment_replies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/post_comment_replies/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPostCommentRepliesIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"post_comment_replies"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/post_comment_replies/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPostCommentReplyPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"post_comment_replies"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/post_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPostCommentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"post_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/study_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminStudyGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"study_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/talk_messages/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTalkMessagePath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"talk_messages"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/talk_rooms/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTalkRoomPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"talk_rooms"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/talk_rooms/:talk_room_code/talk_messages(.:format)
 * @param {any} talkRoomCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTalkRoomTalkMessagesPath = /*#__PURE__*/ __jsr.r({"talk_room_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"talk_rooms"],[2,[7,"/"],[2,[3,"talk_room_code"],[2,[7,"/"],[2,[6,"talk_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/talk_rooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTalkRoomsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"talk_rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_code/black(.:format)
 * @param {any} userCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserBlackPath = /*#__PURE__*/ __jsr.r({"user_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_code"],[2,[7,"/"],[2,[6,"black"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_personal_info_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_personal_info_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_personal_info_applications/:user_personal_info_application_id/draft(.:format)
 * @param {any} userPersonalInfoApplicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPersonalInfoApplicationDraftPath = /*#__PURE__*/ __jsr.r({"user_personal_info_application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_personal_info_applications"],[2,[7,"/"],[2,[3,"user_personal_info_application_id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_personal_info_applications/:user_personal_info_application_id/examination_result(.:format)
 * @param {any} userPersonalInfoApplicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPersonalInfoApplicationExaminationResultPath = /*#__PURE__*/ __jsr.r({"user_personal_info_application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_personal_info_applications"],[2,[7,"/"],[2,[3,"user_personal_info_application_id"],[2,[7,"/"],[2,[6,"examination_result"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_personal_info_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPersonalInfoApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_personal_info_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_code/profile_image(.:format)
 * @param {any} userCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserProfileImagePath = /*#__PURE__*/ __jsr.r({"user_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_code"],[2,[7,"/"],[2,[6,"profile_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_personal_info_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administratorDatabaseAuthenticationRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_personal_info_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administratorDatabaseAuthenticationSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcementPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcementsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bmPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bm"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /business_matching/application_done(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingApplicationDonePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"application_done"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/business_entities/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingBusinessEntityPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"business_entities"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/business_entity_info_application_email_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingBusinessEntityInfoApplicationEmailVerificationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"business_entity_info_application_email_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/business_entity_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingBusinessEntityPreviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"business_entity_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/current_business_entity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingCurrentBusinessEntityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"current_business_entity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/draft_first_business_entity_info_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingDraftFirstBusinessEntityInfoApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"draft_first_business_entity_info_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingOwnedBusinessEntitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:owned_business_entity_code/activation(.:format)
 * @param {any} ownedBusinessEntityCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingOwnedBusinessEntityActivationPath = /*#__PURE__*/ __jsr.r({"owned_business_entity_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"owned_business_entity_code"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:owned_business_entity_code/active_business_entity_info_application(.:format)
 * @param {any} ownedBusinessEntityCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingOwnedBusinessEntityActiveBusinessEntityInfoApplicationPath = /*#__PURE__*/ __jsr.r({"owned_business_entity_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"owned_business_entity_code"],[2,[7,"/"],[2,[6,"active_business_entity_info_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:owned_business_entity_code/business_entity_info_application_email_verification_token(.:format)
 * @param {any} ownedBusinessEntityCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingOwnedBusinessEntityBusinessEntityInfoApplicationEmailVerificationTokenPath = /*#__PURE__*/ __jsr.r({"owned_business_entity_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"owned_business_entity_code"],[2,[7,"/"],[2,[6,"business_entity_info_application_email_verification_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:owned_business_entity_code/draft_edit_business_entity_info_application(.:format)
 * @param {any} ownedBusinessEntityCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingOwnedBusinessEntityDraftEditBusinessEntityInfoApplicationPath = /*#__PURE__*/ __jsr.r({"owned_business_entity_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"owned_business_entity_code"],[2,[7,"/"],[2,[6,"draft_edit_business_entity_info_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:owned_business_entity_code/talk_rooms/:talk_room_code/last_read_talk_message_date_time(.:format)
 * @param {any} ownedBusinessEntityCode
 * @param {any} talkRoomCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingOwnedBusinessEntityTalkRoomLastReadTalkMessageDateTimePath = /*#__PURE__*/ __jsr.r({"owned_business_entity_code":{"r":true},"talk_room_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"owned_business_entity_code"],[2,[7,"/"],[2,[6,"talk_rooms"],[2,[7,"/"],[2,[3,"talk_room_code"],[2,[7,"/"],[2,[6,"last_read_talk_message_date_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:owned_business_entity_code/talk_rooms(.:format)
 * @param {any} ownedBusinessEntityCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingOwnedBusinessEntityTalkRoomsPath = /*#__PURE__*/ __jsr.r({"owned_business_entity_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"owned_business_entity_code"],[2,[7,"/"],[2,[6,"talk_rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /business_matching/samples/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingSamplePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"samples"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/talk_rooms/:talk_room_code/messages(.:format)
 * @param {any} talkRoomCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingTalkRoomMessagesPath = /*#__PURE__*/ __jsr.r({"talk_room_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"talk_rooms"],[2,[7,"/"],[2,[3,"talk_room_code"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/terms_of_service(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingTermsOfServicePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"terms_of_service"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/verification_sent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMatchingVerificationSentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"verification_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confirmation_done(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmationDonePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmation_done"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /confirmation_sent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmationSentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmation_sent"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /current_post_theme(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const currentPostThemePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"current_post_theme"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/auth/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAdministratorDatabaseAuthenticationSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserDatabaseAuthenticationSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_personal_info_application/done(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const doneUserPersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_personal_info_application"],[2,[7,"/"],[2,[6,"done"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAnnouncementPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entities/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminBusinessEntityPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entities"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_entity_info_applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminBusinessEntityInfoApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_entity_info_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_setting/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEventSettingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_setting"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/posts/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPostPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/post_comments/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPostCommentPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"post_comments"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/post_comment_replies/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPostCommentReplyPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"post_comment_replies"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBusinessMatchingOwnedBusinessEntityPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:owned_business_entity_code/activation/edit(.:format)
 * @param {any} ownedBusinessEntityCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBusinessMatchingOwnedBusinessEntityActivationPath = /*#__PURE__*/ __jsr.r({"owned_business_entity_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"owned_business_entity_code"],[2,[7,"/"],[2,[6,"activation"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPostPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/basic/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfileBasicPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"basic"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/email_notification_setting/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfileEmailNotificationSettingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"email_notification_setting"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/guest_user/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfileGuestUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"guest_user"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/official_user/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfileOfficialUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"official_user"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/registration/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfileRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/workplace/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfileWorkplacePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"workplace"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:code/edit(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editStudyGroupPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserDatabaseAuthenticationPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"good_job"]]);

/**
 * Generates rails route to
 * /good_job/batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobBatchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobBatchesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cleaner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobCleanerIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cleaner"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobCronEntriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key(.:format)
 * @param {any} cronKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobCronEntryPath = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/disable(.:format)
 * @param {any} cronKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobDisableCronEntryPath = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobDiscardJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/enable(.:format)
 * @param {any} cronKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobEnableCronEntryPath = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/enqueue(.:format)
 * @param {any} cronKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobEnqueueCronEntryPath = /*#__PURE__*/ __jsr.r({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enqueue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/force_discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobForceDiscardJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/frontend/modules/:version/:id(.:format)
 * @param {any} version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobFrontendModulePath = /*#__PURE__*/ __jsr.r({"version":{"r":true,"d":"4-11-1"},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"version"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/frontend/static/:version/:id(.:format)
 * @param {any} version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobFrontendStaticPath = /*#__PURE__*/ __jsr.r({"version":{"r":true,"d":"4-11-1"},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"static"],[2,[7,"/"],[2,[3,"version"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobMassUpdateJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/metrics/job_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobMetricsJobStatusPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"job_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/metrics/primary_nav(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobMetricsPrimaryNavPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"primary_nav"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/pauses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobPausesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"pauses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/performance/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobPerformancePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"performance"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobPerformanceIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"performance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobProcessesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/reschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobRescheduleJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/batches/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobRetryBatchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobRetryJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goodJobRootPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"good_job"]],[7,"/"]]);

/**
 * Generates rails route to
 * /maintenance_tasks
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"maintenance_tasks"]]);

/**
 * Generates rails route to
 * /maintenance_tasks/tasks/:task_id/runs/:id/cancel
 * @param {any} taskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksCancelTaskRunPath = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true}}, [2,[2,[2,[7,"/"],[6,"maintenance_tasks"]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_tasks/tasks/:task_id/runs/:id/pause
 * @param {any} taskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksPauseTaskRunPath = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true}}, [2,[2,[2,[7,"/"],[6,"maintenance_tasks"]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pause"]]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_tasks/tasks/:task_id/runs/:id/resume
 * @param {any} taskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksResumeTaskRunPath = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true}}, [2,[2,[2,[7,"/"],[6,"maintenance_tasks"]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"resume"]]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_tasks/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksRootPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"maintenance_tasks"]],[7,"/"]]);

/**
 * Generates rails route to
 * /maintenance_tasks/tasks/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksTaskPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[2,[2,[7,"/"],[6,"maintenance_tasks"]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[3,"id"]]]]);

/**
 * Generates rails route to
 * /maintenance_tasks/tasks/:task_id/runs
 * @param {any} taskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksTaskRunsPath = /*#__PURE__*/ __jsr.r({"task_id":{"r":true}}, [2,[2,[2,[7,"/"],[6,"maintenance_tasks"]],[7,"/"]],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[6,"runs"]]]]]]);

/**
 * Generates rails route to
 * /maintenance_tasks/tasks
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenanceTasksTasksPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"maintenance_tasks"]],[7,"/"]],[6,"tasks"]]);

/**
 * Generates rails route to
 * /admin/announcements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAnnouncementPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdministratorDatabaseAuthenticationSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdministratorSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBusinessMatchingOwnedBusinessEntityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newContactPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPostPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/cancel/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProfileCancelPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"cancel"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/personal_info_application/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProfilePersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"personal_info_application"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newStudyGroupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserDatabaseAuthenticationPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserDatabaseAuthenticationRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserDatabaseAuthenticationSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_personal_info_application/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_personal_info_application"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_code/bookmark(.:format)
 * @param {any} postCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postBookmarkPath = /*#__PURE__*/ __jsr.r({"post_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_code"],[2,[7,"/"],[2,[6,"bookmark"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post_comments/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postCommentPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_comments"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /post_comments/:post_comment_code/replies(.:format)
 * @param {any} postCommentCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postCommentRepliesPath = /*#__PURE__*/ __jsr.r({"post_comment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_comments"],[2,[7,"/"],[2,[3,"post_comment_code"],[2,[7,"/"],[2,[6,"replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post_comment_replies/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postCommentReplyPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_comment_replies"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /post_comment_replies/:post_comment_reply_code/useful(.:format)
 * @param {any} postCommentReplyCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postCommentReplyUsefulPath = /*#__PURE__*/ __jsr.r({"post_comment_reply_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_comment_replies"],[2,[7,"/"],[2,[3,"post_comment_reply_code"],[2,[7,"/"],[2,[6,"useful"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post_comments/:post_comment_code/useful(.:format)
 * @param {any} postCommentCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postCommentUsefulPath = /*#__PURE__*/ __jsr.r({"post_comment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_comments"],[2,[7,"/"],[2,[3,"post_comment_code"],[2,[7,"/"],[2,[6,"useful"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_code/comments(.:format)
 * @param {any} postCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postCommentsPath = /*#__PURE__*/ __jsr.r({"post_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_code"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_code/resolved(.:format)
 * @param {any} postCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postResolvedPath = /*#__PURE__*/ __jsr.r({"post_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_code"],[2,[7,"/"],[2,[6,"resolved"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewPostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /privacy_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacyPolicyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile/basic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileBasicPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"basic"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/email_notification_setting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileEmailNotificationSettingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"email_notification_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/guest_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileGuestUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"guest_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/official_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileOfficialUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"official_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/personal_info_application(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"personal_info_application"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/workplace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileWorkplacePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"workplace"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /questions/:question_code/votes(.:format)
 * @param {any} questionCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const questionVotesPath = /*#__PURE__*/ __jsr.r({"question_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"question_code"],[2,[7,"/"],[2,[6,"votes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reset_password_sent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetPasswordSentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reset_password_sent"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /static/business_matching(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staticBusinessMatchingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"static"],[2,[7,"/"],[2,[6,"business_matching"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studyGroupPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:study_group_code/comments(.:format)
 * @param {any} studyGroupCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studyGroupCommentsPath = /*#__PURE__*/ __jsr.r({"study_group_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"study_group_code"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:study_group_code/instructor_image(.:format)
 * @param {any} studyGroupCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studyGroupInstructorImagePath = /*#__PURE__*/ __jsr.r({"study_group_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"study_group_code"],[2,[7,"/"],[2,[6,"instructor_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:study_group_code/thumbnail(.:format)
 * @param {any} studyGroupCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studyGroupThumbnailPath = /*#__PURE__*/ __jsr.r({"study_group_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"study_group_code"],[2,[7,"/"],[2,[6,"thumbnail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /study_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studyGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terms_of_service(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsOfServicePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_service"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_code/commented_replied_posts(.:format)
 * @param {any} userCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userCommentedRepliedPostsPath = /*#__PURE__*/ __jsr.r({"user_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_code"],[2,[7,"/"],[2,[6,"commented_replied_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDatabaseAuthenticationConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDatabaseAuthenticationPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDatabaseAuthenticationRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDatabaseAuthenticationRootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userDatabaseAuthenticationSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_personal_info_application(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_personal_info_application"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_code/posts(.:format)
 * @param {any} userCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPostsPath = /*#__PURE__*/ __jsr.r({"user_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_code"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateBusinessMatchingOwnedBusinessEntitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business_matching/owned_business_entities/:code/validate(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateBusinessMatchingOwnedBusinessEntityPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_matching"],[2,[7,"/"],[2,[6,"owned_business_entities"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/basic/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateProfileBasicPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"basic"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/personal_info_application/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateProfilePersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"personal_info_application"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateUserDatabaseAuthenticationRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_personal_info_application/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateUserPersonalInfoApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_personal_info_application"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:code/view(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewStudyGroupPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

